import type {
  BulletinBoardNoticesSortBy,
  BulletinBoardNoticeStatus,
  ProposalType,
  TimeUnit,
  TransactionType,
} from 'src/apis/secondary-market-service/types';
import type { StatusProps } from 'src/components/data-display/status-display';
import type { Currency } from 'src/utils/currencies';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

export const bulletinBoardNoticesSortByLabels: Record<
  BulletinBoardNoticesSortBy,
  string
> = {
  CREATED_AT: 'Created At',
};

export const bulletinBoardNoticesSortByValues = labelsToValues(
  bulletinBoardNoticesSortByLabels
);
export const bulletinBoardNoticesSortByOptions = labelsToOptions(
  bulletinBoardNoticesSortByLabels
);

export const proposalTypeLabels: Record<ProposalType, string> = {
  PROPOSAL_TO_SELL: 'Sell',
  PROPOSAL_TO_BUY: 'Buy',
};

export const proposalTypeValues = labelsToValues(proposalTypeLabels);
export const proposalTypeOptions = labelsToOptions(proposalTypeLabels);

export const transactionTypeLabels: Record<TransactionType, string> = {
  ASSIGNMENT: 'Assignment',
  TRANSFER_OF_USE: 'Transfer of Use',
};

export const transactionTypeValues = labelsToValues(transactionTypeLabels);
export const transactionTypeOptions = labelsToOptions(transactionTypeLabels);

export const statusLabels: Record<BulletinBoardNoticeStatus, string> = {
  ACTIVE: 'Active',
  ARCHIVED: 'Archived',
};
export const statusVariantMap: Record<
  BulletinBoardNoticeStatus,
  StatusProps['variant']
> = {
  ACTIVE: 'success',
  ARCHIVED: 'inactive',
};

export const statusValues = labelsToValues(statusLabels);
export const statusOptions = labelsToOptions(statusLabels);

export const timeUnitLabels: Record<TimeUnit, string> = {
  DAY: 'd',
  MONTH: 'm',
  QUARTER: 'q',
  YEAR: 'y',
  RUNTIME: 'Runtime',
};

export const timeUnitValues = labelsToValues(timeUnitLabels);
export const timeUnitOptions = labelsToOptions(timeUnitLabels);

export const currencyLabels = {
  EUR: 'EUR',
  CHF: 'CHF',
  HRK: 'HRK',
  GBP: 'GBP',
  DKK: 'DKK',
  CZK: 'CZK',
} satisfies Partial<Record<Currency, string>>;

export const currencyValues = labelsToValues(currencyLabels);
export const currencyOptions = labelsToOptions(currencyLabels);
